import { render, staticRenderFns } from "./LeaveApprovalSettingsTable.vue?vue&type=template&id=41778c12&"
import script from "./LeaveApprovalSettingsTable.vue?vue&type=script&lang=js&"
export * from "./LeaveApprovalSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports